import { useState, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import PageSectionList from '../../../../shared/components/layouts/PageSectionList'
import FormDrawer from '../../../../shared/components/drawers/FormDrawer'
import VolumeForm from './VolumeForm'
import { useConfirmationDialog } from '../../../../system/ConfirmationDialogProvider'

function ServiceStorageTab({
  volumes,
  volumesLoading,
  createVolume,
  updateVolume,
  destroyVolume,
}) {
  const { openConfirmationDialog } = useConfirmationDialog()
  const [drawer, setDrawer] = useState({ open: false, volume: null })

  const handleOpenDrawer = useCallback((volume = null) => {
    setDrawer({ open: true, volume })
  }, [])

  const handleCloseDrawer = useCallback(() => {
    setDrawer({ open: false, volume: null })
  }, [])

  const handleDelete = useCallback((volume) => {
    openConfirmationDialog({
      title: <FormattedMessage id="volumes.delete.title" />,
      message: <FormattedMessage id="volumes.delete.message" />,
      onConfirm: () => destroyVolume(volume.id),
      onCancel: () => Promise.resolve(),
    })
  }, [openConfirmationDialog, destroyVolume])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleOpenDrawer()}
        >
          <FormattedMessage id="dockerServices.show.addVolume" />
        </Button>
      </Box>

      {volumesLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <PageSectionList
          items={volumes}
          emptyId="dockerServices.show.volumesEmpty"
          renderItem={(volume) => ({
            primary: volume.name || volume.targetPath,
            secondary: `${volume.sourcePath || '(project volume)'} → ${volume.targetPath}`,
          })}
          onItemClick={handleOpenDrawer}
          onItemDelete={handleDelete}
        />
      )}

      <FormDrawer
        open={drawer.open}
        onClose={handleCloseDrawer}
        titleId={drawer.volume ? 'volumes.edit.title' : 'volumes.create.title'}
      >
        <VolumeForm
          volume={drawer.volume}
          createVolume={createVolume}
          updateVolume={updateVolume}
          onSuccess={handleCloseDrawer}
          onCancel={handleCloseDrawer}
        />
      </FormDrawer>
    </>
  )
}

export default ServiceStorageTab
